import { render } from "./NewProjects.vue?vue&type=template&id=ed1ca5da&scoped=true"
import script from "./NewProjects.vue?vue&type=script&lang=js"
export * from "./NewProjects.vue?vue&type=script&lang=js"

import "./NewProjects.vue?vue&type=style&index=0&id=ed1ca5da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1ca5da"]])

export default __exports__